/**
 * https://www.msn.com/en-us/play/games/testing/cg-test-game?dev-playground=https://riddles-staging.labsystech.ru/publish/html5-staging/msstart&item=flights:prg-cg-iap-pub
 * https://www.msn.com/en-us/play/games/testing/cg-test-game?dev-playground=https://fairy-staging.labsystech.ru/publish/html5-staging/msstart/&item=flights:prg-cg-iap-pub
 *
 * Created by andrey on 18.11.2024
 */

const MSStartPayments = function () {  
    Payments.call(this, connector.MSSTART, {
        sdk: SdkManager.SDK_MSSTART
    });

    connector.social.whenConnected(() => {
        if (this.socialConnectCallback) {
            this.socialConnectCallback();
            delete this.socialConnectCallback;
        }
    });
};

MSStartPayments.prototype = Object.create(Payments.prototype);
MSStartPayments.prototype.constructor = MSStartPayments;

MSStartPayments.prototype.getProductId = function (config) {
    return config.id.msstart;
};

MSStartPayments.prototype._connect = function (callback) {
    new ConnectorActionPlayer([
        (f) => {
            if (connector.social.isConnected()) {
                f();
            } else {
                this.socialConnectCallback = f;
            }
        },

        (f) => {
            this.updateUserAccountType(f);
        }
    ]).play(() => {
        callback(connector.STATUS_CONNECTED);

        connector.social.on("login", () => {
            this.updateUserAccountType();
        });
    });
};

MSStartPayments.prototype._loadProducts = function (callback) {
    if (!connector.social.isLoggedIn()) {
        console.log("load products failed - not logged in");
        callback(connector.CODE_FAILED);
        return;
    }

    if (this.userAccountType === MSStartPayments.WORK_OR_SCHOOL) {
        console.log("load products failed - work or school account");
        callback(connector.CODE_FAILED);
        return;
    }

    const productIds = this.listProductIdsOfType(["consumable", "nonConsumable"]);
    const loadedProducts = {};

    $msstart.iap.getAllAddOnsAsync({
        productId: connector.config.msstart.appId
    }).then((response) => {
        if (response.code || !Array.isArray(response)) {
            console.log("Failed load ", response);
            callback(connector.CODE_FAILED);

            return;
        }

        productIds.forEach((productId) => {
            const msProduct = response.find((item) => item.productId === productId);
            if (!msProduct) {
                console.log("Failed load ", productId);
                return;
            }

            loadedProducts[productId] = msProduct;

            const price = msProduct.price;
            const ourProduct = this.getProduct(productId);
            if (ourProduct) {
                ourProduct.currency = price.currencyCode;
                ourProduct.price = price.listPrice;
                this.currency = price.currencyCode || this.currency;
                ourProduct.textPrice = this.getTextPrice(ourProduct.price);
            }
            // console.log("loaded product", productId, ourProduct);
        });

        console.log(`Success load products ${Object.keys(loadedProducts).length}`, loadedProducts);
        callback(connector.CODE_SUCCEED, Object.keys(loadedProducts));
    }).catch((error) => {
        console.log("Failed load ", error);

        callback(connector.CODE_FAILED);
    });
};

MSStartPayments.prototype.purchase = function (product, callback) {
    $msstart.iap.purchaseAsync({
        productId: product.productId
    }).then((response) => {
        console.log("success purchase", response);

        const receipt = response.receipt;

        const purchase = this.createPurchase(receipt.orderId, product, {
            receiptSignature: response.receiptSignature,
            receipt
        });

        callback(connector.CODE_SUCCEED, purchase);
    }).catch((e) => {
        console.log("error purchase", e);

        let code = ERRORS.PURCHASE.UNKNOWN;
        const errorCode = e && e.code;
        const errorDescription = (e && e.description || "").toLowerCase();
        const extraErrorCode = e && e.extra && e.extra.errorCode || "";

        // the store holds an unconsumed receipt of the product: the restore delivers it after the answer, the same as
        // ITEM_ALREADY_OWNED on Android (the manager skips a restore while the purchase is still running)
        const alreadyOwned = extraErrorCode === "PUR-UserAlreadyOwnsContent"
            || errorCode === "IAP_PURCHASE_RECEIPT_FAILURE" && errorDescription.startsWith("purchase succeeded but receipt");

        if (errorDescription === "user dismissed the purchase dialog.") {
            code = ERRORS.PURCHASE.CANCEL;
        }

        callback(code, undefined, { error: extraErrorCode || errorCode, message: e && e.description });

        if (alreadyOwned) {
            connector.timeouts.setTimeout(() => connector._paymentsManager.restoreThrottled(), 0);
        }
    });
};

MSStartPayments.prototype.consume = function (purchase, callback) {
    console.log("consume start", purchase);

    if (this.getProduct(purchase.productId).type === "nonConsumable") {
        callback(connector.CODE_SUCCEED);
        return;
    }

    $msstart.iap.consumeAsync({
        productId: purchase.productId
    }).then((response) => {
        console.log("consume success", response);

        callback(connector.CODE_SUCCEED);
    }).catch((e) => {
        console.log("consume error", e);

        callback(ERRORS.CONSUME.UNKNOWN);
    });
};

MSStartPayments.prototype.validate = function (purchase, callback) {
    console.log("Start validate", purchase);

    ConnectorRestClient.post("/msstartpayments/validate", { ...purchase.payload, userId: purchase.userId }, (response) => {
        if (response === "ok") {
            callback(connector.CODE_SUCCEED, purchase);
            console.log("Purchase validation success");
        } else {
            console.log("Purchase validation error", response);
            callback(connector.CODE_FAILED);
        }
    }, () => {
        console.log("Purchase validation network error - skip server validation");
        callback(connector.CODE_SUCCEED, purchase);
    });
};

MSStartPayments.prototype.updateUserAccountType = function (callback) {
    callback = callback || function () {};

    $msstart.getSignedInUserAsync()
        .then((player) => {
            const accountType = (player.userAccountType || "").toLowerCase();
            console.log(`MSStartPayments accountType - ${accountType}`);

            this.userAccountType = accountType.includes("work") || accountType.includes("school")
                ? MSStartPayments.WORK_OR_SCHOOL : MSStartPayments.PERSONAL;

            callback();
        })
        .catch((error) => {
            console.log("MSStartPayments updateUserAccountType error", error);
            callback();
        });
};

MSStartPayments.prototype.restore = function (callback) {
    if (!connector.social.isLoggedIn() || this.userAccountType === MSStartPayments.WORK_OR_SCHOOL) {
        callback(connector.CODE_FAILED);
        return;
    }

    // all the unconsumed purchases of the game in one call, one signature for the whole receipts array
    $msstart.iap.getAllPurchasesAsync({
        productId: connector.config.msstart.appId
    }).then((response) => {
        console.log("MSStartPayments restore", response);

        const receipts = response && Array.isArray(response.receipts) ? response.receipts : [];

        const canFulfill = (receipt) => receipt && receipt.orderId && receipt.status === "Active" && this.getProduct(receipt.productId);

        const granted = (receipt) => this.getProduct(receipt.productId).type === "nonConsumable" && connector._paymentsManager.isConsumed(receipt.orderId);

        const receipt = receipts.find((receipt) => canFulfill(receipt) && !granted(receipt));

        if (!receipt) {
            callback(connector.CODE_FAILED);
            return;
        }

        const product = this.getProduct(receipt.productId);
        const purchase = this.createPurchase(receipt.orderId, product, {
            receiptSignature: response.receiptSignature,
            receipts,
            receipt
        });

        callback(connector.CODE_SUCCEED, purchase);
    }).catch(() => {
        callback(connector.CODE_FAILED);
    });
};

MSStartPayments.isAppropriate = function () {
    return connector.platform.oneOf(connector.MSSTART);
};

MSStartPayments.PERSONAL = "personal";
MSStartPayments.WORK_OR_SCHOOL = "work or school";